import { isEmpty } from "lodash-es";

/**
 * Helper function to build the variant object.
 * @param flags - The flags to build the variant object.
 * @returns The variant object.
 */
export const buildVariantObject = <T extends string>(
  flags: VariantConfig<T>[]
): VariantObject<T> => {
  const variantObject = flags
    .map(({ variantKey, flag, enabled }) => {
      if (isEmpty(variantKey)) return null;

      return {
        [flag]: {
          variantKey: variantKey,
          enabled: enabled || false,
        },
      };
    })
    .filter(Boolean);

  return Object.assign({}, ...variantObject);
};
